import React, {FC, useEffect, useRef, useState} from "react";
import { useNavigate, Link } from "react-router-dom";
import {Formik, Field, Form, FieldInputProps, FormikProps} from "formik";
import axios from "axios";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal"; 
import AllFailureModal from "../shared/AllFailureModal";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
interface Skill {
  skill_id: string;
  skill_name: string;
  skill_shortname: string;
  skill_tag: string;
  skill_category: string;
}

interface SkillsAutocompleteProps {
  value: string | Skill[];
  onChange: (skills: Skill[]) => void;
  onBlur?:  (e: FocusEvent) => void;
  skillsList: Skill[];
}

const SkillsAutocomplete: React.FC<SkillsAutocompleteProps> = ({ value, onChange, onBlur, skillsList }) => {
  const initialValue = Array.isArray(value) ? value : value ? value.split(",").map((v) => ({ skill_id: v, skill_name: v, skill_shortname: "", skill_tag: "", skill_category: "" })) : [];

  const [inputValue, setInputValue] = useState<string>('');
  const [selectedSkills, setSelectedSkills] = useState<Skill[]>(initialValue);
  const [suggestions, setSuggestions] = useState<Skill[]>([]);
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const suggestionsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target as Node)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.trim()) {
      const filtered = skillsList.filter(skill => {
        const searchTerm = value.toLowerCase();
        const alreadySelected = selectedSkills.some(selected => selected.skill_id === skill.skill_id);

        return !alreadySelected && (
            skill.skill_name.toLowerCase().includes(searchTerm) ||
            skill.skill_shortname.toLowerCase().includes(searchTerm) ||
            skill.skill_tag.toLowerCase().includes(searchTerm)
        );
      });
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const addSkill = (skill: Skill) => {
    if (!selectedSkills.some(selected => selected.skill_id === skill.skill_id)) {
      const newSkills = [...selectedSkills, skill];
      setSelectedSkills(newSkills);
      onChange(newSkills);
      setInputValue('');
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const removeSkill = (skillToRemove: Skill) => {
    const newSkills = selectedSkills.filter(skill => skill.skill_id !== skillToRemove.skill_id);
    setSelectedSkills(newSkills);
    onChange(newSkills);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      if (suggestions.length > 0) {
        addSkill(suggestions[0]);
      }
    }
  };

  const renderSkillBadge = (skill: Skill) => {
    const tags = skill?.skill_tag?.split(',').slice(0, 2).map(tag => tag.trim());
    return (
        <span
            key={skill.skill_id}
            className="badge bg-primary me-2 mb-2 d-inline-flex align-items-center"
        >
        <span className="d-flex flex-column">
          <span>{skill.skill_name}</span>
          <small className="text-white-50">
            {tags?.join(' • ')}
          </small>
        </span>
        <button
            type="button"
            className="btn-close btn-close-white ms-2"
            style={{ fontSize: '0.5rem' }}
            onClick={() => removeSkill(skill)}
            aria-label="Remove skill"
        />
      </span>
    );
  };

  const renderSuggestionItem = (skill: Skill) => {
    return (
        <div
            key={skill.skill_id}
            className="p-2 cursor-pointer table-hover border rounded"
            style={{ cursor: 'pointer' }}
            onMouseDown={() => addSkill(skill)}
        >
          <div className="d-flex flex-column">
            <span className="fw-medium">{skill.skill_name}</span>
            <small className="text-muted">
              {skill.skill_category} • {skill.skill_shortname}
            </small>
            <small className="text-muted">
              Tags: {skill.skill_tag}
            </small>
          </div>
        </div>
    );
  };

  return (
      <div className="skills-autocomplete">
        <div className="mb-2">
          {selectedSkills.map(renderSkillBadge)}
        </div>
        <div className="position-relative">
          <input
              type="text"
              ref={inputRef}
              className="form-control"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              onBlur={() => {
                setTimeout(() => setShowSuggestions(false), 200);
              }}
              placeholder="Search skills by name, shortname, or tags..."
          />
          {showSuggestions && suggestions.length > 0 && (
              <div
                  ref={suggestionsRef}
                  className="position-absolute w-100 mt-1 shadow bg-white rounded border"
                  style={{
                    zIndex: 1000,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }}
              >
                {suggestions.map(renderSuggestionItem)}
              </div>
          )}
        </div>
      </div>
  );
};


const CandidateAdd: FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [userId, setUserId] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
   const [successMessage, setSuccessMessage] = useState('');
   const [failureMessage, setFailureMessage] = useState('');
//  const [modalShow, setModalShow] = useState(false);
 const [modalMessage, setModalMessage] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchError, setSearchError] = useState(false);
  const [formError, setFormError] = useState("");
  const [skills, setSkills] = useState<Skill[]>([]);

  const searchUser = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}users/searchuserbyuseridmobile/${searchInput}`
      );
      if (response.data.length > 0) {
        const userData = response.data[0];
        setUserId(userData.userid);
        setSearchError(false);
        setSuccessMessage("User found and User ID is filled!");
        setShowSuccessModal(true);
        // toast.success("User found and User ID is filled!");
      }
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        setUserId("");
        setSearchError(true);
        setFailureMessage("User not found !");
        setShowFailureModal(true);
        // toast.error("User not found.");
      } else {
        console.error("Error searching user:", error);
        setFailureMessage("Failed to find the user. Please try again.");
        setShowFailureModal(true);
        // toast.error("Error searching user.");
      }
    }
  };

  const callApiCandidateAdd = async (values: any) => {
    if (!userId) {
      setFailureMessage("Please search and select a user first.");
      setShowFailureModal(true);
      return { error: true };
    }

    try {
      const url =
        process.env.REACT_APP_API_URL + "candidate_details/createcandidate";
      const response = await axios.post(url, values);
      console.log(response);
      if (response.status === 201) {
        setStatus(true);
        // const token = localStorage.getItem("jwttoken");
        // if (token) {
        //   navigate('/candidate-list');
        // }
        // toast.success("Candidate Added Successfully");
        // navigate("/candidate_details");
        setSuccessMessage("Candidate Added successfully!");
        setShowConfirmationModal(true);
        // setShowSuccessModal(true);
      }
      return {
        error: false,
      };
    } catch (error) {
      console.error("Error adding Candidate:", error);
      setFailureMessage("Failed to add candidate. Please try again.");
      setShowFailureModal(true);
      return {
        error: true,
      };
    }
  };
  useEffect(() => {
    const fetchAllSkills = async () => {
      try {
        const url = process.env.REACT_APP_API_URL + "skills/showallskills";
        const response = await axios.get(url);
        setSkills(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    fetchAllSkills()
  }, [])

  return (
    <>
    <ToastContainer/>
    <div>
      <div className="search-user-section mb-4">
        <div className="row">
          <label htmlFor="search" className="col-4 my-2">
            Enter User ID or Mobile:
          </label>
          <div className="col-8">
            <input
              type="text"
              id="search"
              className="form-control"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Enter User ID or Mobile"
            />
            <button
              type="button"
              className="btn btn-primary mt-2"
              onClick={searchUser}
            >
              Search User
            </button>
          </div>
        </div>
        {searchError && (
          <div className="text-danger text-center mt-2">
            User not found. Please enter a valid User ID or Mobile.
          </div>
        )}
      </div>

      <h4 className="bg-info bg-opacity-25 text-center py-2 mb-3">
        Add Candidate
      </h4>
      <Formik
        enableReinitialize={true}
        initialValues={{
          userid: userId || "",
          city: "",
          hometown: "",
          college: "",
          university: "",
          passing_year: "",
          branch: "",
          isactive: "1",
          whatsapp_mobile: "",
          skills: ""
        }}
        onSubmit={async (values, { resetForm }) => {
          values.userid = userId || "";
          const { error } = await callApiCandidateAdd(values);
          if (!error) {
            resetForm();
          }
        }}
      >
        <div className="row">
          <Form className="examAddForm container">
            <div className="row mb-3">
              <label htmlFor="userid" className="col-md-4 col-form-label">
                User ID:
              </label>
              <div className="col-md-8">
                <Field
                    name="userid"
                    type="text"
                    className="form-control"
                    required
                    readOnly
                    disabled
                    value={userId}
                />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="city" className="col-md-4 col-form-label">
                City:
              </label>
              <div className="col-md-8">
                <Field name="city" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="hometown" className="col-md-4 col-form-label">
                Hometown:
              </label>
              <div className="col-md-8">
                <Field name="hometown" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="college" className="col-md-4 col-form-label">
                College:
              </label>
              <div className="col-md-8">
                <Field name="college" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="university" className="col-md-4 col-form-label">
                University:
              </label>
              <div className="col-md-8">
                <Field name="university" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="skills" className="col-md-4 col-form-label">
                Skills:
              </label>
              <div className="col-md-8">
                <Field name="skills">
                  {({ field, form }: { field: FieldInputProps<any>; form: FormikProps<any> }) => (
                      <SkillsAutocomplete
                          value={field.value || []}
                          onChange={(skills: Skill[]) => form.setFieldValue('skills', skills)}
                          onBlur={field.onBlur}
                          skillsList={skills}
                      />
                  )}
                </Field>
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="passing_year" className="col-md-4 col-form-label">
                Passing Year:
              </label>
              <div className="col-md-8">
                <Field name="passing_year" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="branch" className="col-md-4 col-form-label">
                Branch:
              </label>
              <div className="col-md-8">
                <Field name="branch" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="isactive" className="col-md-4 col-form-label">
                Is Active:
              </label>
              <div className="col-md-8">
                <Field name="isactive" type="text" className="form-control" required />
              </div>
            </div>

            <div className="row mb-3">
              <label htmlFor="whatsapp_mobile" className="col-md-4 col-form-label">
                Whatsapp Mobile:
              </label>
              <div className="col-md-8">
                <Field
                    name="whatsapp_mobile"
                    type="text"
                    className="form-control"
                    required
                />
              </div>
            </div>

            {formError && (
                <div className="row">
                  <div className="col-12 text-danger text-center mt-2">
                    {formError}
                  </div>
                </div>
            )}

            <div className="row">
              <div className="col-12 text-center my-4">
                <button type="submit" className="btn btn-success">
                  Submit
                </button>
                <Link to="/candidate_details" type="button" className="btn btn-danger ms-3" >
                    Go Back
                </Link>
                
              </div>
            </div>
          </Form>

        </div>
      </Formik>
      <ConfirmationModal 
          show={showConfirmationModal} 
          onHide={() => {
            setShowConfirmationModal(false);
            setShowSuccessModal(true); // Show success modal after confirmation
          }} 
          modalMessage="Candidate added successfully!" 
          operationType="OK" 
        />
              <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
                          <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage}  operationType="OK" timeoutDuration={3000}/>
    </div>
  </>
  );
};

export default CandidateAdd;
